import { EMAIL_RE } from '../pages/Account/profileFormUtils';
import { formatPhoneDigitsForAuthLookup, validateLocalMobile } from './phone';

/**
 * @param {{
 *   mode: 'phone' | 'account',
 *   countryCode?: string,
 *   mobile?: string,
 *   accountIdentifier?: string,
 * }} params
 * @returns {{ username: string } | { error: string }}
 */
export function resolveLoginUsername({ mode, countryCode, mobile, accountIdentifier }) {
  if (mode === 'phone') {
    const localDigits = String(mobile ?? '').replace(/\D/g, '');
    if (!localDigits) {
      return { error: 'Please enter your mobile number.' };
    }
    const phoneCheck = validateLocalMobile(mobile, countryCode);
    if (!phoneCheck.ok) {
      return { error: phoneCheck.message };
    }
    const username = formatPhoneDigitsForAuthLookup(countryCode, phoneCheck.digits);
    if (!username) {
      return { error: 'Please enter a valid mobile number.' };
    }
    return { username };
  }

  const account = String(accountIdentifier ?? '').trim();
  if (!account) {
    return { error: 'Please enter your username or email.' };
  }
  if (account.includes('@') && !EMAIL_RE.test(account)) {
    return { error: 'Please enter a valid email address.' };
  }
  return { username: account };
}
